import axiosTokenInstance from "services/api/backoffice";
import { OFFERS, OFFERS_ERROR } from "_models/redux/types";

// Action function
export const getOffers = (params) => async (dispatch) => {
    const { lead_id } = params || {};

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/leads/${lead_id}/get-offers`
        );

        const { data, status } = response || {};

        dispatch({
            type: OFFERS,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: OFFERS_ERROR,
            payload: e || {},
        });
    }
};
